module.exports = __webpack_public_path__ + "img/avatar-53.006bf2de.png";